import React, { useState } from "react";
import { FaInstagram, FaPhone, FaMapMarkerAlt, FaWhatsapp, FaTimes } from "react-icons/fa";

const FaixaComLaco = () => {
  const [mostrarModal, setMostrarModal] = useState(false);

  return (
    <div className="relative bg-[#c9aa7b] py-4 overflow-hidden z-10">
      {/* Conteúdo central */}
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-around items-center gap-4 px-4 text-white text-sm font-medium">
        
        {/* Contato 1 - WhatsApp */}
        <a
          href="https://wa.me/5531993127020?text=Estou%20precisando%20de%20um%20orçamento!"
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center hover:opacity-80 transition"
        >
          <div className="w-10 h-10 rounded-full border-4 border-[#f5f1e8] bg-black flex items-center justify-center mb-2">
            <FaPhone className="text-white text-lg" />
          </div>
          <span>(31) 99312-7020</span>
        </a>

        {/* Contato 2 - Instagram */}
        <a
          href="https://www.instagram.com/higienizacao_prime?igsh=MW9kbXB5OWF1MnVteQ=="
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center hover:opacity-80 transition"
        >
          <div className="w-10 h-10 rounded-full border-4 border-[#f5f1e8] bg-black flex items-center justify-center mb-2">
            <FaInstagram className="text-white text-lg" />
          </div>
          <span>@higienizacao_prime</span>
        </a>

        {/* Contato 3 - Localidade */}
        <div className="flex flex-col items-center">
          <div className="w-10 h-10 rounded-full border-4 border-[#f5f1e8] bg-black flex items-center justify-center mb-2">
            <FaMapMarkerAlt className="text-white text-lg" />
          </div>
          <span>Atendemos todo Vale do Aço - MG</span>
        </div>
      </div>

      {/* Linhas decorativas */}
      <div className="h-1 mt-2 bg-black w-11/12 mx-auto rounded-full" />
      <div className="h-1 bg-white w-10/12 mx-auto mt-1" />

      {/* Créditos finais com botão */}
      <div className="text-center text-xs text-white mt-3">
        © 2025 - Desenvolvido por{" "}
        <button
          onClick={() => setMostrarModal(true)}
          className="underline text-black text-sm hover:text-blue-100"
          style={{ fontFamily: 'Comic Sans MS, Comic Sans, cursive' }}
        >
          Alessandro Ferreira
        </button>
      </div>

      {/* Modal com fundo escuro e centralização */}
      {mostrarModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 px-4">
          <div className="bg-gray-800 text-white rounded-lg p-6 shadow-lg relative max-w-sm w-full">
            <button
              onClick={() => setMostrarModal(false)}
              className="absolute top-2 right-2 text-gray-400 hover:text-red-400"
            >
              <FaTimes size={18} />
            </button>
            <h2 className="text-lg font-semibold mb-4">Desenvolvedor</h2>
            <div className="flex flex-col items-start gap-3">
              <a
                href="https://www.instagram.com/ales_ferreira00"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-pink-400 transition"
              >
                <FaInstagram /> Instagram
              </a>
              <a
                href="https://wa.me/31971465940"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-green-400 transition"
              >
                <FaWhatsapp /> WhatsApp
              </a>
            </div>
          </div>
        </div>
      )}

      {/* SVG decorativo */}
      <svg
        className="absolute top-0 right-0 h-full hidden md:block"
        viewBox="0 0 200 80"
        preserveAspectRatio="none"
        width="200"
        height="100%"
      >
        <polygon points="0,0 100,0 200,80 100,80" fill="#d8d0c7" />
        <polygon points="60,0 160,0 200,80 100,80" fill="#f5f1e8" />
        <polygon points="120,0 200,0 200,80 140,80" fill="#caa874" />
      </svg>
    </div>
  );
};

export default FaixaComLaco;
